export var UserType;
(function (UserType) {
    UserType["user"] = "user";
    UserType["admin"] = "admin";
})(UserType || (UserType = {}));
export var MembershipType;
(function (MembershipType) {
    MembershipType["member"] = "member";
    MembershipType["admin"] = "admin";
    MembershipType["owner"] = "owner";
})(MembershipType || (MembershipType = {}));
export var ExtensionTypes;
(function (ExtensionTypes) {
    ExtensionTypes["installed"] = "installed";
    ExtensionTypes["uninstalled"] = "uninstalled";
    ExtensionTypes["published"] = "published";
    ExtensionTypes["unpublished"] = "unpublished";
})(ExtensionTypes || (ExtensionTypes = {}));
export var FeatureTypes;
(function (FeatureTypes) {
    FeatureTypes["MARKETPLACE"] = "marketplace";
    FeatureTypes["MARKETPLACE_FLAG"] = "marketplace_flag";
    FeatureTypes["EXPORT_MEETING_HISTORY"] = "exportMeetingHistory";
})(FeatureTypes || (FeatureTypes = {}));
export var RoomTypeAttributes;
(function (RoomTypeAttributes) {
    RoomTypeAttributes["PERSONAL_ROOMS"] = "personalRoomsOnLanding";
    RoomTypeAttributes["SHARED_ROOMS"] = "sharedRoomsOnLanding";
})(RoomTypeAttributes || (RoomTypeAttributes = {}));
export var ProfilePictureProvider;
(function (ProfilePictureProvider) {
    ProfilePictureProvider["GRAVATAR"] = "gravatar";
    ProfilePictureProvider["DOXYME_PROFILE_PICTURE"] = "doxymeProfilePicture";
    ProfilePictureProvider["LINKEDIN"] = "LinkedIn";
})(ProfilePictureProvider || (ProfilePictureProvider = {}));
export var SystemActions;
(function (SystemActions) {
    SystemActions["SET_USER"] = "SYSTEM/SET_USER";
    SystemActions["UPDATE_USER"] = "SYSTEM/UPDATE_USER";
    SystemActions["SET_INSTITUTION"] = "SYSTEM/SET_INSTITUTION";
    SystemActions["UPDATE_INSTITUTION"] = "SYSTEM/UPDATE_INSTITUTION";
    SystemActions["UPDATE_INSTITUTION_ACCESS"] = "SYSTEM/UPDATE_INSTITUTION_ACCESS";
    SystemActions["SET_ROOM"] = "SYSTEM/SET_ROOM";
    SystemActions["UPDATE_ROOM"] = "SYSTEM/UPDATE_ROOM";
    SystemActions["SET_ROOMS"] = "SYSTEM/SET_ROOMS";
    SystemActions["SET_LOCATION_DETAILS"] = "SYSTEM/SET_LOCATION_DETAILS";
    SystemActions["SET_PURCHASES"] = "SYSTEM/SET_PURCHASES";
    SystemActions["UPDATE_PURCHASES"] = "SYSTEM/UPDATE_PURCHASES";
    SystemActions["SET_PLANS"] = "SYSTEM/SET_PLANS";
    SystemActions["SET_STATES"] = "SYSTEM/SET_STATES";
    SystemActions["SET_LANGUAGES"] = "SYSTEM/SET_LANGUAGES";
    SystemActions["SET_PERSONAL_DATA"] = "SYSTEM/SET_PERSONAL_DATA";
    SystemActions["SET_LOCATIONS_LICENSED"] = "SYSTEM/SET_LOCATIONS_LICENSED";
    SystemActions["SAVE_AFTER_LOGIN_PATH"] = "SYSTEM/SAVE_AFTER_LOGIN_PATH";
    SystemActions["RESET_AFTER_LOGIN_PATH"] = "SYSTEM/RESET_AFTER_LOGIN_PATH";
    SystemActions["UPDATE_USER_MANAGEABLE_FEATURES"] = "SYSTEM/UPDATE_USER_MANAGEABLE_FEATURES";
})(SystemActions || (SystemActions = {}));
